import { assign, get } from 'lodash';
import { Base64Decode } from 'utils/base64';
import { LocalStoreOptions } from 'services';

import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';

export default {
  props: {
    page: {
      type: Number, // String, Number, Boolean, Function, Object, Array
      required: false,
      default: null,
    },
  },
  components: {
    PageHelp,
  },
  data() {
    return {
      paginationDefault: {
        per_page: 25,
        page: 1,
        sort_by: null,
        order: null,
        q: null,
        letter: null,
        filter: null,
        group_by: null,
      },
      pageSizes: [10, 25, 50, 100, 500],
      paramsDefault: {},
      params: {},
      localStorageKey: null,
      showFilters: true,
      indexPageParamsQuery: null,
      show: {
        pageHelp: false,
      },
    };
  },
  methods: {
    assignParam(key, value, store = false) {
      value = value === '' ? null : value;
      assign(this.params, { [key]: value });
      if (store) {
        if (value) LocalStoreOptions.setByKey(this.localStorageKey, key, value);
        else LocalStoreOptions.removeByKey(this.localStorageKey, key);
      }
    },
    doSearch(input) {
      this.assignParam('q', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doFilterByFirstLetter(input) {
      this.assignParam('letter', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doFilterByOrigin(input) {
      this.assignParam('filter', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doGroupBy(input) {
      this.assignParam('group_by', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doSortBy(input) {
      this.assignParam('sort_by', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doPageChange(input) {
      this.assignParam('page', input);
      this.fetch();
    },
    doPageSizeChange(input) {
      this.assignParam('per_page', input, true);
      this.assignParam('page', 1);
      this.fetch();
    },
    doShowFilters(input) {
      this.showFilters = input;
    },
    doChangeGroupBy(input) {
      this.assignParam('group_by', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doChangeSortBy(input) {
      this.assignParam('sort_by', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    doChangeOrder(input) {
      this.assignParam('order', input);
      this.assignParam('page', 1);
      this.fetch();
    },
    fetch() {},
    clean() {},
  },
  watch: {
    // options: {
    //   handler: (newValue) => {
    //     LocalStoreOptions.set(this.localStorageKey, newValue);
    //   },
    //   deep: true,
    // },
  },
  created() {
    assign(
      this.params,
      this.paginationDefault,
      this.paramsDefault,
    );

    const params = get(this.$route, 'query.params');

    // params exis in query apply them, otherwise load from localstore
    if (params) {
      const decoded = Base64Decode(params);
      console.log('decodedParams', decoded);
      assign(this.params, decoded);
    } else {
      LocalStoreOptions.get(this.localStorageKey, this.params);
    }
    this.fetch();
  },
  beforeDestroy() {
    this.clean();
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/server-side-page-list.js